import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, query, orderBy, onSnapshot, limit, getDocs,where } from "firebase/firestore";
import "../styles/DisplayObs.css";

function TxtObs() {
  const [comments, setComments] = useState([]);
  const [recent10, setRecent10] = useState([]);
  const [users, setUsers] = useState([]);
  const [popupImage, setPopupImage] = useState(null);

  
// 🔹 Fetch only "Centauria Lake Resort" observations
useEffect(() => {
  const commentsRef = collection(db, "observations");
  const q = query(
    commentsRef,
    where("hotelName", "==", "Satarathchandra Textile"), // 🔹 filter by hotel name
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    let commentsData = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // 🔹 Sort locally
    commentsData.sort((a, b) => {
      const dateA = a.createdAt?.toDate?.() || new Date(0);
      const dateB = b.createdAt?.toDate?.() || new Date(0);
      return dateB - dateA;
    });

    setComments(commentsData);
  });

  return () => unsubscribe();
}, []);



  useEffect(() => {
  const fetchUsers = async () => {
    const usersRef = collection(db, "users"); // adjust collection name if needed
    const snapshot = await getDocs(usersRef);
    const allUsers = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setUsers(allUsers);
  };

  fetchUsers();
}, []);

  // Fetch last 10 QR logs
useEffect(() => {
  const fetchRecent10 = async () => {
    const qrRef = collection(db, "reviews");
    const q = query(qrRef, orderBy("createdAt", "desc"), limit(50));
    const snapshot = await getDocs(q);
    const logs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    setRecent10(logs); // <-- store ALL logs
  };

  fetchRecent10();
}, []);


  // Convert Firestore timestamp to readable time
  const timeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);
    if (seconds < 60) return "Just now";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} m`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} h`;
    const days = Math.floor(hours / 24);
    return `${days} d`;
  };

// 🔹 Group comments by email (without domain)
const groupedComments = comments.reduce((acc, c) => {
  const emailPrefix = c.userEmail?.split("@")[0] || "Unknown"; // ✅ take only before "@"
  if (!acc[emailPrefix]) acc[emailPrefix] = [];
  acc[emailPrefix].push(c);
  return acc;
}, {});

return (
  <div className="display-root">
    <h3>Observations 📝</h3>
            {comments.length > 0 ? (
            <ul className="display-comment-list">
                {Object.entries(groupedComments).map(([emailPrefix, userComments]) => (
                <li key={emailPrefix} className="display-comment-item">
                    <span className="display-comment-email">{emailPrefix}</span> {/* ✅ show only prefix */}
                    {userComments.map((c, index) => (
                    <div key={index} className="display-comment-row">
                        <p className="display-comment-text">{c.text}</p>
                        <span className="display-comment-date">
                        {c.updatedAt?.toDate
                            ? timeAgo(c.updatedAt.toDate())
                            : c.createdAt?.toDate
                            ? timeAgo(c.createdAt.toDate())
                            : "Just now"}
                        </span>
                        {c.images && c.images.length > 0 && (
                          <div className="comment-images">
                            {c.images.map((url, i) => (
                              <img
                                key={i}
                                src={url}
                                alt={`comment-${i}`}
                                className="comment-img"
                                onClick={() => setPopupImage(url)}
                                style={{ cursor: "pointer" }}
                              />
                            ))}
                          </div>
                        )}
                    </div>
                    ))}
                </li>
                ))}
            </ul>
            ) : (
            <p>No observations yet.</p>
            )}

            {/* 🔹 IMAGE POPUP */}
          {popupImage && (
            <div
              className="image-popup"
              onClick={() => setPopupImage(null)} // close on click
            >
              <img src={popupImage} alt="popup" className="popup-img" />
            </div>
          )}
  
      <h3>Qr Logs ☑️</h3>
      {recent10.length > 0 ? (
        <ul className="display-comment-list">
          {(() => {
            // Filter out security users
            const nonSecurityLogs = recent10.filter((log) => {
            const user = users.find((u) => u.email === log.userEmail);
            return (
                user?.role?.toLowerCase() !== "security" &&
                log.hotelName?.toLowerCase() === "Sarathchandra Textile".toLowerCase() // ✅ case-insensitive
            );
            });

            // Group remaining logs by email
            const groupedQrLogs = nonSecurityLogs.reduce((acc, log) => {
              const email = log.userEmail?.split("@")[0] || "Unknown";
              if (!acc[email]) acc[email] = [];
              acc[email].push(log);
              return acc;
            }, {});

            return Object.entries(groupedQrLogs).map(([email, logs]) => (
              <li key={email} className="display-comment-item">
                <span className="display-comment-email">{email}</span>
                {logs.map((log, index) => {
                  const logDate = log.createdAt?.toDate ? log.createdAt.toDate() : null;
                  return (
                    <div key={index} className="display-comment-row">

                    {(log.issueHotel || log.issueMaintenance) && (
                          <div className="display-comment-row">
                            <p className="display-comment-text">
                              {/* Show QR Data first */}
                              {log.qrData && <span className="qr-value">{log.qrData}</span>}

                              {/* Separator only if there’s an issue */}
                              {log.qrData && log.issueHotel && " | "}

                              {/* Hotel issue */}
                              {log.issueHotel && (
                                <><span className="issue-hotel">{log.issueHotel}</span></>
                              )}

                              {/* Separator only if both hotel and maintenance issues exist */}
                              {log.issueHotel && log.issueMaintenance && " | "}

                              {/* Maintenance issue */}
                              {log.issueMaintenance && (
                                <><span className="issue-hotel">{log.issueMaintenance}</span></>
                              )}

                              {/* Date at the end */}
                              {log.createdAt && " | "}
                              {log.createdAt && (
                                <span className="display-comment-date">{timeAgo(log.createdAt.toDate())}</span>
                              )}
                            </p>

                          </div>
                        )}

                    </div>
                  );
                })}
              </li>
            ));
          })()}
        </ul>
      ) : (
        <p>No QR logs yet.</p>
      )}

     <h3>Security Logs 🪪</h3>
        {recent10.length > 0 ? (
          <ul className="display-comment-list">
            {(() => {
              // 🔹 Filter only security users in Centauria Lake
              const securityLogs = recent10.filter((log) => {
                const user = users.find((u) => u.email === log.userEmail);
                return (
                  user?.role?.toLowerCase() === "security" &&
                  log.hotelName?.toLowerCase() === "Sarathchandra Textile".toLowerCase()
                );
              });

              // 🔹 Group by email
              const groupedSecurityLogs = securityLogs.reduce((acc, log) => {
                const email = log.userEmail?.split("@")[0] || "Unknown";
                if (!acc[email]) acc[email] = [];
                acc[email].push(log);
                return acc;
              }, {});

              // 🔹 Render grouped logs
              return Object.entries(groupedSecurityLogs).map(([email, logs]) => (
                <li key={email} className="display-comment-item">
                  <span className="display-comment-email">{email}</span>
                  {logs.map((log, index) => {
                    const logDate = log.createdAt?.toDate ? log.createdAt.toDate() : null;
                    return (
                      <div key={index} className="display-comment-row">
                        <p className="display-comment-text">
                          {/* QR Detail */}
                          {log.qrData && <span className="qr-value"> {log.qrData}</span>}

                          {/* Checked Time */}
                          {logDate && (
                            <> | <span className="display-comment-date"> {timeAgo(logDate)}</span></>
                          )}

                          {/* Issues or No Issues */}
                          {log.issueHotel || log.issueMaintenance ? (
                            <>
                              {log.issueHotel && (
                                <> |  <span className="issue-hotel">{log.issueHotel}</span></>
                              )}
                              {log.issueMaintenance && (
                                <> |  <span className="issue-hotel">{log.issueMaintenance}</span></>
                              )}
                            </>
                          ) : (
                            <> | <span className="no-issues">No Issues</span></>
                          )}
                        </p>
                      </div>
                    );
                  })}
                </li>
              ));
            })()}
          </ul>
        ) : (
          <p>No Security logs yet.</p>
        )}

    </div>
  );
}

export default TxtObs;
